import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import HNSColors from "../../../../../../../../ui library/HNSColors";
import { STRINGS } from "../../utils/strings";

const ProviderType = ({ providerId, providerName, onOpenProvider }) => {
  const fullText = providerName ?? "";
  const displayText = fullText.length > 64 ? `${fullText.slice(0, 61)}...` : fullText;

  const handleClick = () => {
    if (!providerId || typeof onOpenProvider !== "function") {
      return;
    }
    onOpenProvider({ pk: providerId, name: providerName });
  };

  return (
    <Tooltip title={fullText || STRINGS.TOOLTIP_PROVIDER_LINK}>
      <Link
        onClick={handleClick}
        className="text-left underline"
        style={{
          color: `var(--report-link-color, ${HNSColors.primary[500]})`,
          transition: "color 150ms ease",
        }}
      >
        {displayText}
      </Link>
    </Tooltip>
  );
};

export default ProviderType;
